export const OPERATING_TZ = "America/Los_Angeles";

export function formatMoney(cents) {
  const value = (Number(cents || 0) / 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `$${value}`;
}

export function toCents(input) {
  if (input === "" || input == null) return 0;
  return Math.round(Number(String(input).replace(/[$,]/g, "")) * 100);
}

export function formatDate(iso, tz = OPERATING_TZ) {
  if (!iso) return "—";
  if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
    const [y, m, d] = iso.split("-").map(Number);
    return new Date(y, m - 1, d).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("es-ES", {
    timeZone: tz,
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatDateTime(iso, tz = OPERATING_TZ) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("es-ES", {
    timeZone: tz,
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatAddress(direccion) {
  if (!direccion) return "—";
  const { calle, ciudad, estado, zip } = direccion;
  return [calle, ciudad, [estado, zip].filter(Boolean).join(" ")].filter(Boolean).join(", ");
}

export function splitMoney(cents) {
  const v = Number(cents || 0) / 100;
  const sign = v < 0 ? "-" : "";
  const abs = Math.abs(v);
  const whole = Math.floor(abs).toLocaleString("en-US");
  const frac = Math.round((abs - Math.floor(abs)) * 100)
    .toString()
    .padStart(2, "0");
  return { sign, whole, frac };
}

export function formatValue(value) {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "boolean") return value ? "Sí" : "No";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
